import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui/box';
import { Typography, withTypography } from 'components/ui/typography';
import { getDesignToken, spacing } from 'styles/constants';

type TypographyProps = React.ComponentPropsWithoutRef<typeof Typography>;

export const FeeDeliveryItem = withTypography({
  color: getDesignToken('alert-warning-background'),
  bold: true,
  focusable: true,
});

export const Total = (props: BoxProps) => React.createElement(Box, { focusable: true, ...props });

export const GrandTotalLabel = withTypography({
  color: getDesignToken('text-default'),
  fontSize: 'md',
  bold: true,
  focusable: true,
  style: { flexGrow: 1 },
});

export const TotalLabel = ({
  isFreeDelivery,
  color,
  style,
  focusable = true,
  ...props
}: TypographyProps & { isFreeDelivery?: boolean; color?: string }) =>
  React.createElement(Typography, {
    color:
      color ||
      (isFreeDelivery
        ? getDesignToken('alert-warning-background')
        : getDesignToken('text-default')),
    fontSize: 'md',
    bold: !!isFreeDelivery,
    style: [{ flexGrow: 1 }, style],
    ...props,
    focusable,
  });

export const DonationLabel = withTypography({
  color: getDesignToken('text-default'),
  focusable: true,
});

export const TotalLabelContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    focusable: true,
    style: [styles.totalLabelContainer, style],
  });

export const TotalsRow = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.totalsRow, style] });

const styles = StyleSheet.create({
  totalLabelContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    height: spacing.$6,
  },
  totalsRow: {
    flexDirection: 'row',
  },
});
